module.exports = __webpack_public_path__ + "img/tongzhi.b2c90b05.jpg";